<template>
    <button :type="type" :class="[styles, size]" class="py-1 font-bold rounded-lg lowercase">
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        type: { default: 'button' },
        variant: { type: String, default: 'primary' },
        width: { default: 'standard' },
    },
    computed: {
        styles() {
            switch (this.variant) {
            case 'blue':
                return 'text-white bg-brand-blue';
            case 'primary':
            default:
                return 'text-white bg-ap-primary';
            }
        },
        size() {
            switch (this.width) {
            case 'full':
                return 'w-full text-lg';
            case 'standard':
            default:
                return 'text-sm px-4 py-2';
            }
        },
    },
};
</script>
